import { SectionProps } from '../types';
import { StyledFabelTownSection } from './style';
import { AutoTextSize } from 'utils/autoTextSizeUtils';

export const FabelTownSection: React.FC<SectionProps> = ({
  sectionName,
  textColor = 'white',
}) => (
  <StyledFabelTownSection className='section-fabeltown' textColor={textColor}>
    <div className='section-fabeltown__content'>
      <AutoTextSize
        as="div"
        maxFontSizePx={16}
        minFontSizePx={12}
        className='section-fabeltown__section-name'
        mode="multiline"
      >
        {sectionName}
      </AutoTextSize>
    </div>
  </StyledFabelTownSection>
);
